export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  LOADING_APPOINTMENT: `Loading appointment...`,
  LOADING_VIDEO: `Loading video...`,
  LANDING_PAGE_HEADING: `Welcome to your online appointment`,
  LANDING_PAGE_APPT_DETAILS: `Appointment with <1/> {{providerName}} <1/> scheduled for`,
  LANDING_PAGE_BEFORE_START: `Before we start, please enter your name and relationship to patient.`,
  LANDING_PAGE_NAME_PLACEHOLDER: `Name, patient/mother/caregiver/etc.`,
  LANDING_PAGE_TERMS: `By joining the telehealth encounter, I agree to the `,
  LANDING_PAGE_TERMS_CONSENT: `By joining the telehealth encounter, I agree to the `,
  LANDING_PAGE_TERMS_NO_MARKUP: `By joining the telehealth encounter, I agree to the athenaTelehealth Terms of Use and Informed Patient Consent.`,
  LANDING_PAGE_TERMS_HEADING: `athenaTelehealth Terms of Use and Informed Patient Consent`,
  LANDING_PAGE_TERMS_CLOSE: `Close`,
  LANDING_PAGE_READY_BTN: `Ok, I’m ready`,
  LANDING_PAGE_NAME_LABEL: `Enter your name followed by your relationship to the patient`,

  CALL_SUMMARY_PAGE_HEADING: `Thank you`,
  CALL_SUMMARY_DETAILS: `Your appointment with {{provider}} is finished.`,
  CALL_SUMMARY_FOLLOWUP: `We will follow up with care instructions if needed.
    Please call your provider if you have questions in the meantime.`,
  CALL_SUMMARY_CUTOFF: `If your call got cut off, rejoin via the invite link.`,
  CALL_SUMMARY_CLOSE: `You may now close this window.`,

  FEEDBACK_THOUGHTS: `Got thoughts?`,
  FEEDBACK_BTN: `Give us feedback`,

  BLOCKED_PATIENT_PRIVACY: `Sorry, the practice has requested privacy for this telehealth session`,
  BLOCKED_PATIENT_CONTACT: `Contact your practice if you think you have received this message in error.`,

  // NEW TRANSLATIONS
  LANDING_PAGE_APPT_DETAILS_INTRO: `Get ready for your visit with`,
  LANDING_PAGE_APPT_DETAILS_PROVIDER: `{{providerName}} on `,
  LANDING_PAGE_NAME_LABEL_2: `What is your full name?`,
  LANDING_PAGE_NAME_PLACEHOLDER_2: `- Type your name - `,
  LANDING_PAGE_PATIENT_LABEL: `Are you the patient?`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_1: `Yes, I am the patient `,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_2: `No, I am a caregiver `,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_3: `No, I am a family member `,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_4: `No, I am a friend `,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_5: `No, I am another care provider`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_6: `No, I am an interpreter`,
  LANDING_PAGE_PATIENT_DROPDOWN_OPTION_7: `Other`,
  LANDING_PAGE_CHECKBOX_DISCLAIMER: `By joining the telehealth encounter, I agree to the athenaTelehealth Terms of Use and Informed Patient Consent.`,
  LANDING_PAGE_SIGNPOST: `Click <strong>Allow</strong> when your browser asks for access to your camera and microphone.`,
  LANDING_PAGE_NEXT_BUTTON: `Next`,
  LANDING_PAGE_CONSENT_ERROR: `We need your consent. Please check the box to proceed.`,
  LANDING_PAGE_NAME_ERROR: `We need your name to proceed.`,
  LANDING_PAGE_APPT_START_DATE: `{{date}} at {{time}}`,
  LANDING_PAGE_CONSENT_HEADING: `Consent for Telehealth Treatment`,

  CALL_SUMMARY_PAGE_THANK_YOU: `Thank you {{patientName}},`,
  CALL_SUMMARY_PAGE_HEADING_2: `Your visit is finished`,
  CALL_SUMMARY_PAGE_FOLLOW_UP: `Please call your care team if you have any follow up questions. `,
  CALL_SUMMARY_PAGE_SIGNPOST: `Do you want to schedule visits, message your care team, or stay on top of your health online?`,
  CALL_SUMMARY_PAGE_SIGNPOST_LINK: `Go to the patient portal`,
  CALL_SUMMARY_PAGE_REPORT_BUTTON: `Report a Technical Issue`,
  CALL_SUMMARY_PAGE_SFPI_BANNER_CONTENT: `Got thoughts?`,
  CALL_SUMMARY_PAGE_SFPI_BANNER_BUTTON: `Give Us Feedback`,

  READINESS_CHECK_WELCOME: `Welcome {{patientName}},`,
  READINESS_CHECK_START: `Let's first check your settings`,
  READINESS_CHECK_AUDIO_OUTPUT_CHECK_LOADING: `Loading your {{deviceName}}`,
  READINESS_CHECK_AUDIO_INPUT_CHECK_LOADING: `Loading your {{deviceName}}`,
  READINESS_CHECK_VIDEO_INPUT_CHECK_LOADING: `Loading your {{deviceName}}`,
  READINESS_CHECK_AUDIO_OUTPUT: `speakers ...`,
  READINESS_CHECK_AUDIO_INPUT: `microphone ...`,
  READINESS_CHECK_VIDEO_INPUT: `camera ...`,
  READINESS_CHECK_NETWORK_CHECK: `Checking your network ...`,
  READINESS_CHECK_NETWORK_CHECK_ISSUE_ALERT: `Network issue detected.`,
  READINESS_CHECK_NETWORK_ERROR_TITLE: `Network Error`,
  READINESS_CHECK_NETWORK_ERROR_TITLE_CONNECTION_ISSUE: `Connection issues`,
  READINESS_CHECK_NETWORK_ERROR_CONTENT: `A network error was detected. Please try to start athenaTelehealth again. If you continue to see this error, call your practice.`,
  READINESS_CHECK_NETWORK_ERROR_CONTENT_CONNECTION_ISSUE: `Disable your VPN, check your firewall, or use your mobile network (data rates might apply).`,
  READINESS_CHECK_NETWORK_ERROR_TRY_AGAIN: `Try Again`,
  READINESS_CHECK_NETWORK_ERROR_CANCEL: `Cancel`,

  READINESS_CHECK_ISSUE_ALERT_SPEAKER: `Speaker not detected.`,
  READINESS_CHECK_ISSUE_ALERT_MICROPHONE: `Microphone not detected.`,
  READINESS_CHECK_ISSUE_ALERT_MICROPHONE_AND_SPEAKER: `Microphone & speaker not detected.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA: `Camera not detected.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA_AND_SPEAKER: `Camera & speaker not detected.`,
  READINESS_CHECK_ISSUE_ALERT_CAMERA_AND_MICROPHONE: `Camera & microphone not detected.`,
  READINESS_CHECK_ISSUE_ALERT_NO_INPUTS: `No input devices detected.`,

  LANGUAGE_BUTTON: `¿Prefieres español?`,
  LANGUAGE_BUTTON_SHORT: `Español`,

  LOADING_APPOINTMENT_2: `Loading your appointment...`,
  LOADING_APPOINTMENT_3: `Loading your virtual visit...`,

  IMAGE_ALT_CATWOMAN: `Woman at home with cat`,
  IMAGE_ALT_TREEDOG: `Thank you tree and dog`,

  FEEDBACK_QUESTION_AUDIO: `How was your experience with the audio quality?`,
  FEEDBACK_QUESTION_VIDEO: `How was your experience with the video quality?`,
  FEEDBACK_QUESTION_OVERALL: `How was your overall call quality experience?`,
  FEEDBACK_GIVE_MORE_FEEDBACK: `Give Us More Feedback`,
  FEEDBACK_BAD: `Bad`,
  FEEDBACK_EXCELLENT: `Excellent`,
  FEEDBACK_THANKYOU: `Thank you for your response`,

  EXPERIENCE_RATING_SUBMIT: 'Submit Rating',
  EXPERIENCE_RATING_WARNING: 'Please select a star rating to submit.',

  // re-skinned readiness check page
  READINESS_CHECK_PAGE_STATUS: `Getting you ready`,
  READINESS_CHECK_PAGE_HEADING: `Setting up your device(s)...`,
  READINESS_CHECK_PAGE_SUB_TEXT: `Stay on this page, and your call will start when your care team is ready.`,

  // duplicated here because we re-skinned the readines check page but want to keep the same i18n namespaces for testing etc
  WAITING_ROOM_SIGNPOST_CONNECTIVITY: `Pro tip - is your internet connection as strong as it could be? If not, move closer to your WiFi router.`,
  WAITING_ROOM_SIGNPOST_PRIVACY: `Pro tip - are you in a private place? If not, move somewhere you are comfortable asking questions about your health.`,
  WAITING_ROOM_SIGNPOST_STREAMING: `Pro tip - is someone else sharing your internet bandwidth? Make sure no one is streaming video or playing video games.`,
  WAITING_ROOM_SIGNPOST_UNUSED_TABS: `Pro tip - have you closed any unused apps and browser tabs? Make sure your bandwidth is as strong as it can be.`,
  WAITING_ROOM_SIGNPOST_DO_NOT_DISTURB: `Pro tip - enable ‘Do Not Disturb’ on your device for at least 1 hour to avoid dropping out if someone calls you.`,

  // footer
  FOOTER_A11Y_STATEMENT: `Accessibility Statement`,

  // Page titles
  TITLE_VISIT_SIGN_IN: `Telehealth - Visit Sign In`,
  TITLE_READINESS_CHECK: `Telehealth - Readiness Check`,
  TITLE_WAITING_ROOM: `Telehealth - Waiting Room`,
  TITLE_VISIT_IN_PROGRESS: `Telehealth - Visit In Progress`,
  TITLE_VISIT_ENDED: `Telehealth - Visit Ended`,
  TITLE_INVALID_VISIT_LINK: `Telehealth - Invalid Visit Link`,
  TITLE_DEVICE_CHECK: `Telehealth - Device Check`,
  TITLE_SPEAKER_CHECK: `Telehealth - Speaker Check`,
  TITLE_MICROPHONE_CHECK: `Telehealth - Microphone Check`,
  TITLE_CAMERA_CHECK: `Telehealth - Camera Check`,
  TITLE_DEVICE_CHECK_COMPLETE: `Telehealth - Device Check Complete`,
  TITLE_FAQ: `Telehealth - FAQ & Troubleshooting`,
  TITLE_DEVICE_ACCESS_ISSUE: `Telehealth - Device Access Issue`,
};
